import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=b3080aca&scoped=true&"
var script = {}
import style0 from "./Disclaimers.vue?vue&type=style&index=0&id=b3080aca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3080aca",
  null
  
)

export default component.exports